import type { CreateWorkflowInput } from '@idc-forms/schemas'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateWorkflowMutation } from '../hooks/use-workflow-mutations'
import { WorkflowForm } from './workflow-form'

type WorkflowCreatePanelProps = {
  onDone?: () => void
}

/** "Nuevo flujo de trabajo" dentro del side panel: el mismo WorkflowForm que la edición. */
export function WorkflowCreatePanel({ onDone }: WorkflowCreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateWorkflowMutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: CreateWorkflowInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <WorkflowForm
      submitLabel="Crear flujo de trabajo"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
